export function exportToCSV(data, filename) {
  if (!data || data.length === 0) return;
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row => headers.map(h => {
      const val = row[h];
      if (val === null || val === undefined) return '""';
      const str = String(val).replace(/"/g, '""');
      return `"${str}"`;
    }).join(','))
  ].join('\n');
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
}

export async function exportAllData(apiUrl) {
  const endpoints = [
    { url: `${apiUrl}/api/products`, filename: 'products' },
    { url: `${apiUrl}/api/customers`, filename: 'customers' },
    { url: `${apiUrl}/api/reports/stock-value`, filename: 'stock_report' },
    { url: `${apiUrl}/api/reports/sales-history`, filename: 'sales_history' },
    { url: `${apiUrl}/api/reports/stock-movement`, filename: 'stock_movement' },
    { url: `${apiUrl}/api/reports/tax`, filename: 'tax_report' },
  ];

  const results = [];
  for (const ep of endpoints) {
    try {
      const res = await fetch(ep.url, { credentials: 'include' });
      if (res.ok) {
        let data = await res.json();
        // Tax report has nested structure
        if (ep.filename === 'tax_report') {
          const taxSummary = [{
            tax_collected: data.tax_collected,
            tax_paid: data.tax_paid,
            net_tax: data.net_tax,
            sale_count: data.sale_count,
            purchase_count: data.purchase_count,
          }];
          exportToCSV(taxSummary, 'tax_summary');
          if (data.sales_details?.length) exportToCSV(data.sales_details, 'tax_on_sales');
          if (data.purchase_details?.length) exportToCSV(data.purchase_details, 'tax_on_purchases');
          results.push(ep.filename);
          continue;
        }
        if (Array.isArray(data) && data.length > 0) {
          exportToCSV(data, ep.filename);
          results.push(ep.filename);
        }
      }
    } catch (err) {
      console.error(`Failed to export ${ep.filename}:`, err);
    }
  }
  return results;
}
